<template>
  <div class="row row-cols-2 g-3">
    <div
      v-for="inspection_type in inspection_types"
      :key="inspection_type.id"
      class="col"
    >
      <button
        @click="goToList(inspection_type)"
        class="btn btn-lg btn-secondary w-100 py-4"
      >
        {{ inspection_type.name }}
      </button>
    </div>
  </div>
</template>

<script>
import store from '../store'

export default {
  name: 'OperateMenuInspectionMonitor',
  components: {},

  computed: {
    inspection_types() {
      return store.getters['operate_inspection_type/list']
    },
  },
  async created() {
    await this.fetchInspectionTypeList()
  },
  methods: {
    fetchInspectionTypeList() {
      return store.dispatch('operate_inspection_type/fetchList')
    },
    goToList(inspection_type) {
      store.commit('operate_inspection_plan/setInspectionType', inspection_type)
      this.$router.push({
        name: 'OperateInspectionMonitor',
      })
    },
  },
}
</script>
